import _ from 'lodash';
import 'whatwg-fetch';
import fetchDefaults from 'fetch-defaults';
import fetchJsonify from 'fetch-jsonify';
import fetchThrow from 'fetch-throw';
import FetchError from 'fetch-error';

const _fetch = fetchDefaults(fetch, {
  credentials: 'include',
  headers: { Accept: 'application/json' },
});

export default function api<T>(url, _opts = {}): Promise<T> {
  const { delay, ...opts } = _opts;

  return _.flow([fetchJsonify, fetchThrow])(_fetch)(url, opts)
    .then(res => {
      if (isJsonContent(res)) {
        if (res.status === 303) {
          return res.json().then(({ url: redirectUrl }) => {
            window.location.href = `${redirectUrl}?redirectUrl=${window.location.href}`;
          });
        }

        if (_opts.method === 'HEAD') {
          return;
        }

        return res.json();
      }

      return undefined;
    })
    .catch(error => {
      if (error instanceof FetchError && error.response && isJsonContent(error.response)) {
        return error.response.json().then(res => {
          // eslint-disable-next-line no-throw-literal
          throw { body: res, code: error.code };
        });
      } else {
        throw error;
      }
    });
}

api.get = (url, json) => api(url, { json, method: 'GET' });
api.post = (url, json) => api(url, { json, method: 'POST' });
api.put = (url, json) => api(url, { json, method: 'PUT' });
api.patch = (url, json) => api(url, { json, method: 'PATCH' });
api.head = url => api(url, { method: 'HEAD' });
api.delete = (url, json) => api(url, { json, method: 'DELETE' });

function isJsonContent(res) {
  const contentType = res.headers.get('content-type');

  return contentType && contentType.indexOf('application/json') !== -1;
}
